import { stringifyGraph } from '@/clients/http'
import { OrderSourceModel } from '@/http/models/OrderSource'

import { UseFetchListForm, useFetchList } from '@/hooks/useFetchList'

import { OrderSourceHttpParams, OrderSourceModel as OrderSourceType } from '@/types'

export interface OrderSourceListFilters {
  search?: string
}

export interface OrderSourceListForm extends UseFetchListForm<
  OrderSourceListFilters,
  OrderSourceType.OrderSource
> {}

interface UseFetchOrderSourcesProps {
  sort?: string | null
  shouldFetchList?: boolean
}

export const orderSourceInitialFilters: OrderSourceListFilters = {
  search: '',
}

export const useFetchOrderSources = ({ sort, shouldFetchList }: UseFetchOrderSourcesProps) => {
  return useFetchList<
    OrderSourceListFilters,
    OrderSourceType.OrderSource,
    {},
    any,
    typeof OrderSourceModel.getList
  >({
    pageSize: 10,
    initialFilters: orderSourceInitialFilters,
    fetchFunction: OrderSourceModel.getList,
    sort,
    register: shouldFetchList,
    buildQueryParams: (filters): Partial<OrderSourceHttpParams.GetList['query']> => ({
      search: filters.search || undefined,
      graph_enc: stringifyGraph({
        '*': true,
        'orders.count': true,
      }),
    }),
    buildParams: () => ({}),
  })
}
